import {
  Box,
  Button,
  Container,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useToast
} from "@chakra-ui/react";
import { partial } from "filesize";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";
import trResourcesService from "../../../services/trainer/trResources.service";

const UploadResource = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [content_types, setContentTypes] = useState<any[]>();
  const [audio, setAudio] = useState(false);
  const [video, setVideo] = useState(false);
  const [image, setImage] = useState(false);
  const [links, setLinks] = useState(false);
  const [article, setArticle] = useState(false);
  const [filetype, setFiletype] = useState<string | undefined>("");
  const [batchFile, setbatchFile] = useState<File | undefined>();
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [filename, setFilename] = useState("");
  const [contenttype, setContentType] = useState("");
  const [courseId, setCourseId] = useState("");
  const params = useParams();

  useEffect(() => {
    const course_id: any = params.course_id;

    setCourseId(course_id);
  }, [courseId]);

  useEffect(() => {
    const contentTypes = [
      {
        id: "document",
        title: "Article",
      },
      {
        id: "video",
        title: "Video",
      },
      {
        id: "audio",
        title: "Audio",
      },
      {
        id: "image",
        title: "Image",
      },
      {
        id: "text",
        title: "Link",
      },
    ];
    setContentTypes(contentTypes);
  }, []);

  const showContentType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (e.target.value == "audio") {
      setAudio(true);
      setVideo(false);
      setArticle(false);
      setImage(false);
      setFilename("");
      setLinks(false);
      setbatchFile(undefined);
      setContentType("Audio");
    }
    if (e.target.value == "video") {
      setAudio(false);
      setVideo(true);
      setArticle(false);
      setImage(false);
      setFilename("");
      setLinks(false);
      setbatchFile(undefined);
      setContentType("Video");
    }
    if (e.target.value == "document") {
      setAudio(false);
      setVideo(false);
      setArticle(true);
      setImage(false);
      setFilename("");
      setbatchFile(undefined);
      setLinks(false);
      setContentType("Document");
    }
    if (e.target.value == "image") {
      setAudio(false);
      setVideo(false);
      setArticle(false);
      setImage(true);
      setFilename("");
      setLinks(false);
      setbatchFile(undefined);
      setContentType("Image");
    }
    if (e.target.value == "text") {
      setAudio(false);
      setVideo(false);
      setArticle(false);
      setImage(false);
      setFilename("");
      setLinks(true);
      setbatchFile(undefined);
      setContentType("Link");
    }
  };

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      return errors;
    },
    initialValues: {
      description: "",
      audio_file: "",
      video_file: "",
      article_file: "",
      link: "",
    },
    onSubmit: async (values) => {
      try {
        if (batchFile !== undefined) {
          const formData = new FormData();
          formData.append("description", values.description);
          formData.append("link", values.link);
          formData.append("type", contenttype);
          formData.append("file", batchFile);
          const resourceupload = await trResourcesService.createCourseResource(
            formData,
            courseId
          );
          if (resourceupload) {
            navigate(-1);
            toast({
              title: "Course Resource",
              description: "Course resource upload successful",
              status: "success",
            });
          }
        } else {
          const formData = new FormData();
          formData.append("description", values.description);
          formData.append("link", values.link);
          formData.append("type", contenttype);
          formData.append("file", "");

          const resourceupload = await trResourcesService.createCourseResource(
            formData,
            courseId
          );
          if (resourceupload) {
            navigate(-1);
            toast({
              title: "Course Resource",
              description: "Course resource upload successful",
              status: "success",
            });
          }
        }
      } catch (error: any) {
        toast({
          title: "Course Resource",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value) {
      const fileName = e.target.files?.item(0)?.name as string;

      const fileType = e.target.files?.item(0)?.type;

      const file = e.target.files?.item(0) as File;

      if (fileType?.split("/").at(0) !== "audio" && audio) {
        formik.setErrors({ audio_file: "Only Audio file format is supported" });
        return;
      } else if (fileType?.split("/").at(0) !== "video" && video) {
        formik.setErrors({ video_file: "Only Video file format is supported" });
        return;
      } else if (fileType?.split("/").at(0) !== "image" && image) {
        formik.setErrors({
          article_file: "Only JPG/PNG file format is supported",
        });
        return;
      } else {
        setFilename(fileName);
        setFiletype(fileType);
        setbatchFile(file);
        const fileSize = partial({ base: 2, standard: "jedec" });
        setUploadFileSize(fileSize(file.size));
      }
    } else {
      setFilename("");
      setbatchFile(undefined);
    }

    formik.handleChange(e);
  };

  return (
    <Box minHeight="100vh" bg="#F9F8F8">
      <Container
        width={["90%", "90%", "65%", "58%"]}
        // maxWidth={"84%"}
        px={0}
        pt={["50px", "70px", "100px", "100px"]}
        right={0}
        bg="F9F8F8"
        mx="auto"
      >
        <Box
          mb="60px"
          display="flex"
          alignItems="center"
          border="1px solid #616161"
          px="5px"
          py="7px"
          width={["100px", "120px", "130px", "130px"]}
          borderRadius="5px"
          cursor="pointer"
        >
          <HiArrowNarrowLeft color="#616161" fontSize="20px" />
          <Text
            fontSize="14px"
            color="#616161"
            pl="5px"
            onClick={() => navigate(-1)}
            fontWeight={700}
          >
            Go Back
          </Text>
        </Box>
        <Box
          bg="white"
          px={["20px", "40px", "45px", "45px"]}
          py={["40px", "40px", "45px", "50px"]}
          boxShadow={"0px 0px 5.02px 0px #00000026"}
          borderRadius={"10px"}
        >
          <Text
            color={"#1E1E1E"}
            fontSize={{
              lg: "28px",
              md: "20px",
              sm: "18px",
              base: "18px",
            }}
            fontWeight={"600"}
          >
            Upload Files
          </Text>
          <form onSubmit={formik.handleSubmit}>
            <Box mt={4}>
              <FormControl
                mb="25px"
                isInvalid={
                  formik.errors.description && formik.touched.description
                    ? true
                    : false
                }
              >
                <FormLabel fontWeight="700" color="#353535" fontSize={13}>
                  Resource Description
                </FormLabel>
                <Flex>
                  <Input
                    bg="inputText.500"
                    placeholder="Enter description"
                    value={formik.values.description}
                    name="description"
                    onChange={formik.handleChange}
                    fontSize={12}
                  />
                  {/* <Center ml='20px'><BsCheckCircle fontSize='28px' /></Center> */}
                </Flex>
              </FormControl>
              <FormErrorMessage fontSize={12}>
                {formik.errors.description}
              </FormErrorMessage>

              <Flex justifyContent="space-between">
                <FormLabel
                  mt="10px"
                  fontWeight="700"
                  color="#353535"
                  width="200px"
                  fontSize={13}
                >
                  Content Type
                </FormLabel>
                <Select
                  variant="outline"
                  width="300px"
                  mt="5px"
                  bg="inputText.500"
                  size="md"
                  placeholder="Select content type"
                  name="contentType"
                  onChange={(e) => {
                    showContentType(e);
                  }}
                  fontSize={12}
                  color="brand.subtitle"
                >
                  {content_types?.map((each) => (
                    <option key={each.id} value={each.id}>
                      {" "}
                      {each.title}{" "}
                    </option>
                  ))}
                </Select>
              </Flex>
              {filename ? (
                <Box>
                  <Table variant="unstyled">
                    <Thead fontWeight="semibold">
                      <Tr color="brand.subtitle" fontSize={14}>
                        <Td>Filename</Td>
                        <Td>Type</Td>

                        <Td>Size</Td>
                      </Tr>
                    </Thead>

                    <Tbody>
                      <Tr fontSize={13} color="brand.subtitle">
                        <Td maxW="20em">{filename}</Td>
                        <Td>{filetype}</Td>
                        <Td>{uploadFileSize}</Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </Box>
              ) : audio ? (
                <FormControl mr={10}>
                  <FormLabel fontWeight="600" color="#616161" fontSize={13}>
                    Upload Audio
                  </FormLabel>
                  <Text fontWeight="400" color="#959595" fontSize="14px">
                    Upload an audio resource to the course. (Not larger than
                    2MB)
                  </Text>

                  <input
                    accept="audio/*"
                    type="file"
                    name="audio_file"
                    ref={inputRef}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: "none" }}
                  ></input>
                  <Input
                    cursor="pointer"
                    placeholder="No file selected"
                    defaultValue={filename}
                    mt="10px"
                    height="100px"
                    borderColor="#eeeeee"
                    fontSize={14}
                    bg="#fafafa"
                    onClick={() => inputRef?.current?.click()}
                    border="2px dashed"
                    borderRadius={2}
                  />

                  <FormErrorMessage fontSize={12}>
                    {" "}
                    {formik.errors.video_file}{" "}
                  </FormErrorMessage>
                </FormControl>
              ) : video ? (
                <FormControl mr={10}>
                  <FormLabel fontWeight="600" color="#616161" fontSize={13}>
                    Upload Video
                  </FormLabel>
                  <Text fontWeight="400" color="#959595" fontSize="14px">
                    Upload a video resource to the course. (Not larger than 1MB)
                  </Text>

                  <input
                    accept="video/*"
                    type="file"
                    name="video_file"
                    ref={inputRef}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: "none" }}
                  ></input>
                  <Input
                    cursor="pointer"
                    placeholder="No file selected"
                    defaultValue={filename}
                    mt="10px"
                    height="100px"
                    borderColor="#eeeeee"
                    fontSize={14}
                    bg="#fafafa"
                    onClick={() => inputRef?.current?.click()}
                    border="2px dashed"
                    borderRadius={2}
                  />

                  <FormErrorMessage fontSize={12}>
                    {" "}
                    {formik.errors.video_file}{" "}
                  </FormErrorMessage>
                </FormControl>
              ) : article ? (
                <FormControl mr={10}>
                  <FormLabel fontWeight="600" color="#616161" fontSize={13}>
                    Upload Article
                  </FormLabel>
                  <Text fontWeight="400" color="#959595" fontSize="14px">
                    Upload an article resource to the course. (Not larger than
                    1MB)
                  </Text>

                  <input
                    accept="application/pdf"
                    type="file"
                    name="article_file"
                    ref={inputRef}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: "none" }}
                  ></input>
                  <Input
                    cursor="pointer"
                    placeholder="No file selected"
                    defaultValue={filename}
                    mt="10px"
                    height="100px"
                    borderColor="#eeeeee"
                    fontSize={14}
                    bg="#fafafa"
                    onClick={() => inputRef?.current?.click()}
                    border="2px dashed"
                    borderRadius={2}
                  />

                  <FormErrorMessage fontSize={12}>
                    {" "}
                    {formik.errors.article_file}{" "}
                  </FormErrorMessage>
                </FormControl>
              ) : image ? (
                <FormControl mr={10}>
                  <FormLabel fontWeight="600" color="#616161" fontSize={13}>
                    Upload Image
                  </FormLabel>
                  <Text fontWeight="400" color="#959595" fontSize="14px">
                    Upload an Image resource to the course. (Not larger than
                    1MB)
                  </Text>

                  <input
                    accept="image/*"
                    type="file"
                    name="image_file"
                    ref={inputRef}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: "none" }}
                  ></input>
                  <Input
                    cursor="pointer"
                    placeholder="No file selected"
                    defaultValue={filename}
                    mt="10px"
                    height="100px"
                    borderColor="#eeeeee"
                    fontSize={14}
                    bg="#fafafa"
                    onClick={() => inputRef?.current?.click()}
                    border="2px dashed"
                    borderRadius={2}
                  />

                  <FormErrorMessage fontSize={12}>
                    {" "}
                    {formik.errors.article_file}{" "}
                  </FormErrorMessage>
                </FormControl>
              ) : links ? (
                <FormControl
                  mb="25px"
                  isInvalid={
                    formik.errors.link && formik.touched.link ? true : false
                  }
                >
                  <FormLabel fontWeight="700" color="#353535" fontSize={13}>
                    Link
                  </FormLabel>
                  <Flex>
                    <Input
                      bg="inputText.500"
                      placeholder="Enter link"
                      value={formik.values.link}
                      name="link"
                      onChange={formik.handleChange}
                      fontSize={12}
                    />
                  </Flex>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.link}
                  </FormErrorMessage>
                </FormControl>
              ) : (
                <Box></Box>
              )}
              <Flex mb="100px" justifyContent="center" mt={6}>

                  <Button
                    py="13px"
                    type="submit"
                    px="7px"
                    mt="30px"
                    isLoading={formik.isSubmitting}
                    fontSize={11}
                    borderRadius={2}
                    colorScheme="red"
                    size="sm"
                  >
                    UPLOAD RESOURCE
                  </Button>

              </Flex>
            </Box>
          </form>
        </Box>
      </Container>
    </Box>
  );
};

export default UploadResource;
